/**
 * Confidence threshold constants for field validation UI
 * Single source of truth for confidence-based color coding and flagging
 */

/** Fields below this threshold are shown in error/red state */
export const CONFIDENCE_LOW_THRESHOLD = 60;

/** Fields below this threshold are shown in warning/yellow state; at or above = success/green */
export const CONFIDENCE_HIGH_THRESHOLD = 80;
